import * as angular from "angular";
import { DialogUtils } from "../../../helper/dialog.helper";
import { FieldDataProvider } from "../../../data-provider/field.dp";
import { Field } from "../../../models/field.model";
import { DashboardDataProvider } from "../../../data-provider/dashboard.dp";
import { DashboardWidget } from "../../../models/dashboard-widget.model";
import { ChartHelper } from "../../result/chart.helper";
import { Dashboard } from "../../../models/dashboard.model";
import { CanvassStatusDataProvider } from "../../../data-provider/canvass-status.dp";
import { CanvassStatus } from "../../../models/canvass-status.model";

let FullscreenWidgetComponent = {
    selector: "vcFullscreenWidget",
    templateUrl:
        "/angular/components/dashboard/widget/fullscreen-widget.component.html",
    bindings: {
        widget: "=?",
        dashboard: "=?",
    },
    controller: class FullscreenWidgetController {
        // * bindings for typescript compiler *
        public widget: DashboardWidget;
        public dashboard: Dashboard;
        // ************************************

        public accessType: string | number;
        public name: string;
        public step: number = 1;
        public customFields: Field[];

        public canvassStatuses: CanvassStatus[];
        private dialog: DialogUtils;
        private fieldDataProvider: FieldDataProvider;
        private dataProvider: DashboardDataProvider;
        private chartHelper: ChartHelper;

        public saving: boolean = false;

        constructor(
            DialogUtils: DialogUtils,
            FieldDataProvider: FieldDataProvider,
            ChartHelper: ChartHelper,
            DashboardDataProvider: DashboardDataProvider,
            CanvassStatusDataProvider: CanvassStatusDataProvider
        ) {
            this.dialog = DialogUtils;
            this.dataProvider = DashboardDataProvider;
            this.fieldDataProvider = FieldDataProvider;
            this.chartHelper = ChartHelper;
        }

        $onInit() {}

        cancel(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("dashboard")
    .component(FullscreenWidgetComponent.selector, FullscreenWidgetComponent);
